import React from "react";
import { PRIVACY_POLICY_URL } from "../../../constants/optInDisclaimerFields";

const PrivacyDisclaimerText = ({ linkUrl = PRIVACY_POLICY_URL, style = {} }) => (
  <p style={{ fontSize: "14px", color: "#495057", margin: 0, ...style }}>
    By registering, you agree to our{" "}
    <a
      href={linkUrl}
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "#F68A20", fontWeight: 600 }}
    >
      Privacy Policy
    </a>
    .
  </p>
);

export default PrivacyDisclaimerText;
